// import Vue from 'vue'
import Vuex from 'vuex'
import helpers from './modules/helpers';
import user from './modules/user';
import notifications from './modules/notification';
import subjects from './modules/subject';
import aulas from './modules/aulas';
import periodos from './modules/periodos';
import category from './modules/category';
import avaliacao from './modules/avaliacao';
import password from './modules/password';
import email from './modules/email';
import banner from './modules/banner';
import whatsapp from './modules/whatsapp';
import language from './modules/language';
import cropper_image from './modules/cropper_image';
import document from './modules/document';
import progress from './modules/progress';
import image from './modules/image';
import live_event from './modules/live_event';
import event from './modules/event';
import certificado from './modules/certificado';
import tenant from './modules/tenant';
import notificacaoGeral from './modules/notificacaoGeral';
import coordenador from './modules/coordenador';
import faq from './modules/faq';

export default new Vuex.Store({
    modules: {
        helpers,
        user,
        notifications,
        subjects,
        aulas,
        periodos,
        category,
        avaliacao,
        password,
        email,
        banner,
        whatsapp,
        language,
        cropper_image,
        document,
        progress,
        image,
        live_event,
        event,
        certificado,
        tenant,
        notificacaoGeral,
        coordenador,
        faq
    }
})
